<template>
	<div class="ds" ref="minHeight">
		<img src="@/static/img/qipai/banner.png" alt="banner" class="banner" />
		<div class="content">
			<div class="start_game">
				<img src="@/static/img/qipai/qipai.png" />
				<p>全网最流畅娱乐平台, 最多棋牌游戏, <br />最强投注体验！</p>
				<span @click="startGame">进入游戏<img src="@/static/img/arrow.png" alt="arrow" /></span>
			</div>
		</div>
	</div>
</template>

<script>
import { game } from "../../mixins/game";

export default {
	name: "qipai",
	mixins: [game],
	methods: {
		startGame() {
			this.toGame(this.$store.state.apiTypeMap[7].api[0]);
		},
	},
};
</script>

<style lang="scss" scoped>
.ds {
	width: 100%;
	min-width: 1200px;
	min-height: 784px;
	background: url("~@/static/img/bg.jpg");
	overflow: hidden;
	position: relative;
	.banner {
		position: absolute;
		bottom: 65px;
		left: 50%;
		transform: translateX(-50%);
	}
	.content {
		position: absolute;
		bottom: 45px;
		left: 50%;
		transform: translateX(-50%);
		width: 900px;
		height: 150px;
		background-image: url(~@/static/img/electron/bg.png);
	}
	.start_game {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		padding-left: 31px;
		padding-right: 20px;
		p {
			font-size: 21px;
			color: #fff;
			text-align: center;
		}
		span {
			display: block;
			background-image: url(~@/static/img/game-start-btn.png);
			width: 210px;
			height: 53px;
			background-size: cover;
			background-repeat: no-repeat;
			font-size: 27px;
			// 			font-weight: 600;
			font-weight: 400;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			img {
				margin-left: 10px;
			}
			&:hover {
				animation: gelatin 0.5s 1;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/qipaiGames/qipaiGames.vue